import { of } from 'rxjs';
import { Producer } from '../../models/producer.model';
var producersListMock = [
    {
        name: 'KELLER MARIA CELIA',
        firstName: 'MARIA CELIA',
        lastName: 'KELLER',
        cuit: '27-05256745-4',
        fullProducerCode: null,
        branchOffice: 2,
        number: 51,
        organizerNumber: 900001,
        organizer: {
            branchOffice: 2,
            number: 900001,
            name: 'San Cristobal',
            firstName: null,
            lastName: null,
            cuit: '34-50004533-9',
            fullOrganizerCode: null,
        },
    },
    {
        name: 'KELLER MARIA CELIA',
        firstName: 'MARIA CELIA',
        lastName: 'KELLER',
        cuit: '27-05256745-4',
        fullProducerCode: null,
        branchOffice: 2,
        number: 5697,
        organizerNumber: 900001,
        organizer: {
            branchOffice: 2,
            number: 900001,
            name: 'San Cristobal',
            firstName: null,
            lastName: null,
            cuit: '34-50004533-9',
            fullOrganizerCode: null,
        },
    },
    {
        name: 'KELLER MARIA CELIA',
        firstName: 'MARIA CELIA',
        lastName: 'KELLER',
        cuit: '27-05256745-4',
        fullProducerCode: null,
        branchOffice: 2,
        number: 5722,
        organizerNumber: 900001,
        organizer: {
            branchOffice: 2,
            number: 900001,
            name: 'San Cristobal',
            firstName: null,
            lastName: null,
            cuit: '34-50004533-9',
            fullOrganizerCode: null,
        },
    },
];
var organizerListMock = [
    {
        name: 'KELLER MARIA CELIA',
        firstName: 'MARIA CELIA',
        lastName: 'KELLER',
        cuit: '27-05256745-4',
        fullProducerCode: null,
        branchOffice: 2,
        number: 51
    },
    {
        name: 'KELLER MARIA CELIA',
        firstName: 'MARIA CELIA',
        lastName: 'KELLER',
        cuit: '27-05256745-4',
        fullProducerCode: null,
        branchOffice: 2,
        number: 5697
    },
    {
        name: 'KELLER MARIA CELIA',
        firstName: 'MARIA CELIA',
        lastName: 'KELLER',
        cuit: '27-05256745-4',
        fullProducerCode: null,
        branchOffice: 2,
        number: 5722
    }
];
var ProducerServiceStub = /** @class */ (function () {
    function ProducerServiceStub() {
        this.producers = producersListMock;
        this.organizers = organizerListMock;
    }
    Object.defineProperty(ProducerServiceStub.prototype, "currentProducerValue", {
        get: function () {
            return new Producer();
        },
        enumerable: true,
        configurable: true
    });
    ProducerServiceStub.prototype.getByUserID = function (param) {
        if (param === 1) {
            return of([producersListMock[1]]);
        }
        else if (param === 2) {
            return of([producersListMock[2]]);
        }
        return of([producersListMock[1]]);
    };
    ProducerServiceStub.prototype.getLoggedInProducerWithCuit = function (cuitWithOutLastDigit) {
        return this.producers.find(function (producer) { return producer.cuit.replace(/[-]*/g, '').startsWith(cuitWithOutLastDigit); });
    };
    ProducerServiceStub.prototype.getFormattedProducerCode = function () {
        return '';
    };
    ProducerServiceStub.prototype.getProducersInfoByCurrentUser = function () {
        return of();
    };
    ProducerServiceStub.prototype.getProducerHigherRole = function () { };
    return ProducerServiceStub;
}());
export { ProducerServiceStub };
